import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../utils/quiz-parser.js";
import "../../../context/DevToolsContext.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizImage, getStyles } from "./print-common.js";
function ExplanationPrint({
  quizId: _quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: s.problemArea, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "w-full min-h-[120px] border-[1.5px] border-[#ccc] border-solid rounded-[6px] bg-white",
        style: {
          backgroundImage: "repeating-linear-gradient(to bottom, transparent, transparent 31px, #e5e5e5 31px, #e5e5e5 32px)",
          backgroundPosition: "0 8px"
        },
        children: showCorrectAnswers && correctAnswers && correctAnswers.length > 0 && /* @__PURE__ */ jsx("div", { className: "p-[8px] text-[14px] text-gray-500 font-medium", children: /* @__PURE__ */ jsx(KatexText, { text: correctAnswers.join(", ") }) })
      }
    ) })
  ] });
}
export {
  ExplanationPrint
};
//# sourceMappingURL=explanation-print.js.map
